import { render, staticRenderFns } from "./DomainsPanel.vue?vue&type=template&id=3e25b613"
import script from "./DomainsPanel.vue?vue&type=script&lang=js"
export * from "./DomainsPanel.vue?vue&type=script&lang=js"
import style0 from "./DomainsPanel.vue?vue&type=style&index=0&id=3e25b613&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports